import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/landing/Header";
import HeroSlider from "@/components/landing/HeroSlider";
import Benefits from "@/components/landing/Benefits";
import Program from "@/components/landing/Program";
import Methodology from "@/components/landing/Methodology";
import Testimonials from "@/components/landing/Testimonials";
import ContactForm from "@/components/landing/ContactForm";
import Footer from "@/components/landing/Footer";
import WhatsAppFloat from "@/components/landing/WhatsAppFloat";

function App() {
  return (
    <div className="min-h-screen bg-white text-slate-900 antialiased">
      <Header />
      <main>
        <HeroSlider />
        <Benefits />
        <Program />
        <Methodology />
        <Testimonials />
        <ContactForm />
      </main>
      <Footer />
      <WhatsAppFloat />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
